module.exports = __webpack_public_path__ + "static/media/tictactoebg.ebb15170.png";